import { render } from "./LoginRegister2.vue?vue&type=template&id=0f188a1d&scoped=true"
import script from "./LoginRegister2.vue?vue&type=script&lang=js"
export * from "./LoginRegister2.vue?vue&type=script&lang=js"

import "./LoginRegister2.vue?vue&type=style&index=0&id=0f188a1d&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f188a1d"]])

export default __exports__